import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DepartmentRegisterState, departmentRegisterFeatureKey } from './department-register.reducer';

const departmentRegisterSelector = createFeatureSelector<DepartmentRegisterState>(departmentRegisterFeatureKey);

export const selectFilters = createSelector(departmentRegisterSelector, (state) => {
   return state.filters;
});

export const selectEntities = createSelector(departmentRegisterSelector, (state) => {
   return state.entities;
});

export const selectDepartmentNames = createSelector(departmentRegisterSelector, (state) => {
   return state.departmentNames;
});
